export default {
    'default.root': '/dashboard',
    'default.auth': '/:lang?',
    'auth.login.email': '/:lang?',
    'auth.module': '/:redirect?',
    'auth.login.token': '/authenticate/token',
    'auth.password.reset': '/authenticate/password/reset',
    'auth.password.create': '/authenticate/password/create/:language/:token',
    'auth.password.update': '/authenticate/password/update/:language/:token',
    signup: '/signup/:lang?',
    'config.configuration.manage': '/config/configuration/:category',
    'config.user.permission.manage': '/config/users/:id/permissions',
    'config.field.manage': '/config/fields',
    'config.identity.manage': '/settings/identity',
    'config.language.manage': '/settings/languages',
    'config.currency.manage': '/settings/currencies',
    'config.currency.update': '/settings/currencies/edit/:id',
    'config.fee.manage': '/settings/fees',
    'config.fee.create': '/settings/fees/create',
    'config.fee.update': '/settings/fees/edit/:id',
    'config.tax.manage': '/settings/taxes',
    'config.tax.create': '/settings/taxes/create',
    'config.tax.update': '/settings/taxes/edit/:id',
    'config.accountGroup.manage': '/settings/accountGroup',
    'config.alert.manage': '/settings/alerts',
    'config.alert.create': '/settings/alerts/create',
    'config.alert.update': '/settings/alerts/edit/:id',
    'term.manage': '/settings/terms',
    'term.create': '/settings/terms/create',
    'term.update': '/settings/terms/edit/:id',
    // New routes structure
    'asset.manage': '/assets',
    'asset.update': '/assets/edit/:id',
    'asset.partner.update': '/assets/edit/:id/partner/:partnerId',
    'flow.manage': '/flows',
    'flow.update': '/flows/edit/:id',
    'flow.create': '/flows/create',
    'flow.executions': '/flows/executions',
    'flow.execution': '/flows/executions/:id',
    'flow.incidents': '/flows/incidents',
    'client.manage': '/contacts/companies',
    'client.create': '/contacts/companies/create',
    'client.update': '/contacts/companies/edit/:id',
    'client.location.create': '/contacts/companies/locations/:id',
    'client.location.update': '/contacts/companies/locations/edit/:id/:location',
    'client.find': '/contacts/companies/map',
    'shared.client.manage': '/contacts/companies/shared',
    'contact.manage': '/contacts/records',
    'contact.create': '/contacts/records/create',
    'contact.update': '/contacts/records/edit/:id',
    'shared.contact.manage': '/contacts/records/shared',
    'contact.location.create': '/contacts/:id/locations',
    'contact.location.update': '/contacts/locations/edit/:id/:location',
    'connection.manage': '/connections',
    'connection.detail': '/connections/:id',
    'news.manage': '/content/news',
    'news.create': '/content/news/create',
    'news.update': '/content/news/edit/:id',
    'news.view': '/content/news/view/:id',
    'content.manage': '/content/documents',
    'content.create': '/content/documents/create',
    'content.update': '/content/documents/edit/:id',
    'config.fieldGroup.manage': '/data/fields/groups',
    'config.fieldGroup.create': '/data/fields/groups/create',
    'config.fieldGroup.update': '/data/fields/groups/edit/:id/:tab?',
    'config.field.create': '/data/fields/custom/create/:group',
    'config.field.update': '/data/fields/custom/edit/:group/:id',
    dashboard: '/dashboard',
    'reminder.manage': '/reminders',
    'agent.inbox': '/agent',
    'calendar.manage': '/calendar',
    'deal.manage': '/quotes',
    'agreement.manage': '/agreements',
    'deal.create': '/quotes/create',
    'deal.details': '/quotes/details/:id/:orderId?',
    'deal.configure': '/quotes/configure/:id',
    quote: '/interactive-quote/:id/:preview?',
    quickQuote: '/quick-quote',
    form: '/form/:lang?',
    store: '/store/:lang?',
    'store.partner': '/store/:lang/p/:partnerSlug',
    'store.enhance': '/store/:lang/enhance/:id',
    portal: '/portal/:lang?',
    'order.manage': '/quotes/orders',
    'order.abandoned': '/quotes/abandoned-sales',
    'order.update': '/orders/edit/:id',
    'taskAndAction.manage': '/tasks',
    'taskAndAction.update': '/tasks/:id',
    // Menu alias of taskAndAction.manage (distinct permission)
    'functionSheet.manage': '/tasks',
    'order.confirmation': '/orders/confirmation/:id',
    'order.manufacturing.approval': '/orders/approval/:id',
    'organization.manage': '/organization',
    'organization.unit.create': '/organization/units/create',
    'organization.unit.update': '/organization/units/edit/:id',
    'organization.level.create': '/organization/levels/create',
    'organization.level.update': '/organization/levels/edit/:id',
    'partner.manage': '/partners/contacts/companies',
    'partner.create': '/partners/contacts/companies/create',
    'partner.update': '/partners/contacts/companies/edit/:id',
    'partner.find': '/partners/contacts/map',
    'partner.contact.manage': '/partners/contacts/records',
    'partner.location.create': '/partners/contacts/locations/:id',
    'partner.location.update': '/partners/contacts/locations/edit/:id/:location',
    'resource.manage': '/resources',
    'resource.create': '/resources/create',
    'resource.update': '/resources/edit/:id',
    'saleItem.manage': '/products',
    'saleItem.create': '/products/create',
    'saleItem.update': '/products/edit/:id/:tab?',
    'saleItemGroup.manage': '/products/categories',
    'saleItemGroup.create': '/products/categories/create',
    'saleItemGroup.update': '/products/categories/edit/:id',
    'manufacturing.manage': '/products/elements',
    'manufacturing.create': '/products/elements/create',
    'manufacturing.update': '/products/elements/edit/:id',
    'saleItemOption.manage': '/products/options',
    'saleItemOption.create': '/products/options/create',
    'saleItemOption.update': '/products/options/edit/:id',
    'saleItemPackage.manage': '/products/packages',
    'saleItemPackage.create': '/products/packages/create',
    'saleItemPackage.update': '/products/packages/edit/:id',
    'saleItemPriceList.manage': '/products/price-lists',
    'saleItemPriceList.create': '/products/price-lists/create',
    'saleItemPriceList.update': '/products/price-lists/edit/:id',
    'saleAgreement.manage': '/sale-agreements',
    'saleAgreement.create': '/sale-agreements/create',
    'saleAgreement.update': '/sale-agreements/edit/:id',
    'saleItemVariant.update': '/products/variants/edit/:saleItemId/:id',
    'voucher.manage': '/vouchers',
    'voucher.create': '/vouchers/create',
    'voucher.update': '/vouchers/edit/:id',
    'voucher.status': '/vouchers/status/:id?',
    'terminal.manage': '/vouchers/terminals',
    // The floor app. Outside the authenticated shell: it is opened by scanning
    // a QR and authenticates with a device token, not a session.
    'terminal.pair': '/terminal/pair/:code',
    'terminal.app': '/terminal',
    'promoCode.manage': '/promo-codes',
    'promoCode.create': '/promo-codes/create',
    'promoCode.update': '/promo-codes/edit/:id',
    'config.information.manage': '/settings/account',
    'config.group.manage': '/users/groups',
    'config.group.create': '/users/groups/create',
    'config.group.update': '/users/groups/edit/:id',
    'config.user.manage': '/users',
    'config.user.create': '/users/create',
    'config.user.update': '/users/edit/:id',
    'user.profile': '/user/profile',
    'user.signout': '/signout',
    // Other routes
    'deal.hubspot.create': '/deals/hubspot/create',
    'deal.pipedrive.create': '/deals/pipedrive/create',
    'dataValidation.manage': '/data-validation/manage',
    'dataReport.manage': '/data-report/manage',
    'public.forms.update': '/public/update-organization/:id',
    unauthorized: '/unauthorized',
    search: '/search',
    'zea.manage': '/zea/manage',
    pipedrive: '/pipedrive',
    // Hub
    'hub.overview': '/hub',
    'hub.issues': '/hub/issues',
    'hub.designSystem': '/hub/design-system',
    'hub.account': '/hub/account/:view?',
    'hub.account.update': '/hub/account/edit/:id',
    'hub.documentation.manage': '/hub/documentation',
    'hub.documentation.create': '/hub/documentation/create',
    'hub.documentation.update': '/hub/documentation/edit/:id',
    'hub.documentation.proposal': '/hub/documentation/drafts/:id',
    'config.dealStage.manage': '/settings/deal-stages',
    'config.dealStage.create': '/settings/deal-stages/create',
    'config.dealStage.update': '/settings/deal-stages/edit/:id',
    'config.refusalReason.manage': '/settings/refusal-reasons',
    'config.refusalReason.create': '/settings/refusal-reasons/create',
    'config.refusalReason.update': '/settings/refusal-reasons/edit/:id',
    'config.tag.manage': '/settings/tags',
    'config.tag.create': '/settings/tags/create',
    'config.tag.update': '/settings/tags/edit/:id',
    // Public Documentation
    'documentation.browse': '/documentation',
    'documentation.view': '/documentation/:id'
};
